<template>
  <v-card>
    <v-form @keyup.native.enter.prevent="submit" @submit="submit" onSubmit="return false;">
      
      <v-card-title class="headline py-2">
        {{formText.title}}
        <v-spacer></v-spacer>
        <v-btn icon @click="closeDialog" class="mx-0"><v-icon>close</v-icon></v-btn>
      </v-card-title>
      <v-divider></v-divider>
      
      <v-card-text>
          <dantser-tree
            label="Подразделение, которому подчиняется"
            :source="container_tree"
            ref="parentContainer"
            :field="true"
            :selectMode="1"
            @node-dblclick="setParent($event)"
          >
          </dantser-tree>
      
          <v-text-field
            v-model="data.name"
            label="Название"
            :error-messages="veeErrors.collect('Название')"
            v-validate="'required'"
            data-vv-name="Название"
            required
          ></v-text-field>
      
          <div class="mb-2">
            <label class="v-label theme--light" style="font-size: 13px">Описание</label>
            <dantser-editor v-model="data.description" :init="config" :api-key="apiKey"></dantser-editor>
          </div>
      
          <dantser-tree
            label="Тип подразделения"
            :source="types"
            :field="true"
            ref="containerTypes"
            :selectMode="1"
            @node-dblclick="setType($event)"
            clearable
            @clear="data.type_id = null"
          >
          </dantser-tree>
      
          <v-select
            label="Доступные интерфейсы"
            :items="roles"
            v-model="data.role"
            item-text="name"
            item-value="id"
            no-data-text="Нет доступных интерфейсов"></v-select>
      </v-card-text>
      <v-divider></v-divider>
      
      <v-card-actions class="pa-3">
        <v-btn @click.prevent="submit" :disabled="status.btnDisabled" color="success">{{formText.btn}}</v-btn>
        <span :class="status.className" class="ml-2">{{status.text}}</span>
      </v-card-actions>
      
    </v-form>
  </v-card>
</template>

<script>
  import {mapState} from 'vuex'
  
  export default {
    name: 'NewGroupForm',
    
    props: {
      editMode:{
        type: Boolean,
        default: false
      },
      data:{
        type: Object,
        required: true
      },
      dialog:{
        type: Boolean,
        default:false,
        required:true
      },
      types:{
        type: Array,
        required: true
      },
      container_tree:{
        type: Array,
        required: true
      }
    },

    computed:{
      formText(){
        return this.editMode ? {btn:'Сохранить', title: 'Редактировать подразделение'} : {btn:'Добавить', title:'Добавить новое подразделение'}
      },
      ...mapState('orgstructure', {
        config: state => state.editorBaseConfig,
        apiKey: state => state.editorApiKey,
      }),
    },

    mounted(){
      this.getRoles()
      this.$nextTick(function () {
        this.$refs['parentContainer'].setSelected(this.data.parent_id)
        this.$refs['containerTypes'].setSelected(this.data.type_id)
      })
    },

    data(){
      return {
        roles:[
          {
            value: 1,
            text:'Администратор системы'
          },
          {
            value: 2,
            text:'Администратор группы'
          },
          {
            value: 3,
            text:'Пользователь'
          }
        ],
        status:{
          btnDisabled: false,
          text: '',
          className:'secondary--text darken-1'
        }
      }
    },

    methods:{
      getRoles(){
        this.$store.dispatch('orgstructure/interfaces/list', 'group').then( response => {
          this.roles = response.roles
          if(!this.data.role) this.data.role = this.roles[0].id
        })
      },
      
      submit(){
        this.$validator.validateAll().then( result => {
          if (result) {
            this.status={ btnDisabled: true, text: 'Сохранение', className:'secondary--text lighten-1' }

            if(this.editMode){
              this.$store.dispatch('orgstructure/updateContainer', {id: this.data.id, data: this.data}).then( response => {
                this.status={ btnDisabled: false, text: 'Сохранено', className:'success--text darken-1' }
                this.$emit('change',{
                  type:'edit-container',
                  data:response.container
                })
                this.closeDialog()
              }).catch( error => {
                this.status={ btnDisabled: false, text: 'Ошибка', className:'error--text darken-1' }
              })
            } else {
              this.$store.dispatch('orgstructure/createContainer', this.data).then( response => {
                this.status={ btnDisabled: false, text: 'Сохранено', className:'success--text darken-1' }
                this.$emit('change',{
                  type:'add-container',
                  data:response.container
                })
                this.closeDialog()
              }).catch( error => {
                this.status={ btnDisabled: false, text: 'Ошибка', className:'error--text darken-1' }
              })
            }
            return false
          }
        })
      },
      
      closeDialog(){
        this.$emit('close-dialog')
        this.status.text = ''
        this.$refs['containerTypes'].clear()
      },
      
      setType(eventData){
        this.data.type_id = eventData.id
      },
      
      setParent(eventData){
        this.data.parent_id = eventData.id
      },
    }
  }
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/apps/org/components/Orgschema/Forms/NewGroupForm.vue